import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Features() {
  const { ref: sectionRef, isVisible } = useScrollAnimation();
  const { ref: headRef, isVisible: headVisible } = useScrollAnimation({ threshold: 0.2 });

  const features = [
    {
      icon: 'ri-line-chart-line',
      title: 'Real-Time Analytics',
      description: 'Monitor your business metrics in real-time with live dashboards and instant data updates across all channels.',
      link: '#analytics'
    },
    {
      icon: 'ri-database-2-line',
      title: 'Data Visualization',
      description: 'Transform complex data into beautiful, interactive charts and graphs that make insights instantly clear.',
      link: '#visualization'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Advanced Security',
      description: 'Enterprise-grade encryption and security protocols to keep your sensitive data protected at all times.',
      link: '#security'
    },
    {
      icon: 'ri-links-line',
      title: 'Seamless Integration',
      description: 'Connect with your favorite tools and platforms through our extensive API and pre-built integrations.',
      link: '#integration'
    },
  ];

  return (
    <section id="features" className="py-24 bg-gray-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-16">
        <div
          ref={headRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-16 transition-all duration-700 ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
            Powerful Features for Modern Business
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Everything you need to protect, analyze, and grow your business with cutting-edge technology
          </p>
        </div>

        <div
          ref={sectionRef as React.RefObject<HTMLDivElement>}
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {features.map((feature, index) => (
            <a
              key={index}
              href={feature.link}
              className={`bg-gray-800/50 p-8 rounded-2xl border border-gray-700 hover:border-teal-500/50 hover:shadow-xl hover:shadow-teal-500/10 transition-all cursor-pointer group ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}
              style={{ transitionDuration: '600ms', transitionDelay: `${index * 120}ms` }}
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal-500/20 rounded-xl mb-6 group-hover:bg-teal-500 transition-colors border border-teal-500/30">
                <i className={`${feature.icon} text-2xl text-teal-400 group-hover:text-gray-900 transition-colors`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
              <p className="text-gray-400 leading-relaxed">{feature.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
